import { render, staticRenderFns } from "./JNJQRcode.vue?vue&type=template&id=6ac840d6&scoped=true&"
import script from "./JNJQRcode.vue?vue&type=script&lang=js&"
export * from "./JNJQRcode.vue?vue&type=script&lang=js&"
import style0 from "./JNJQRcode.vue?vue&type=style&index=0&id=6ac840d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac840d6",
  null
  
)

export default component.exports